<template>
    <div>
        <div v-if="alterationShow">
            <div class="shipper_box ab_list">

                <div class="steps1" v-for="(item,index) in dataList.Traces" v-bind:key="index">
                    <div v-if="!(showBtn&&index>1)" style="display:flex">
                        <div v-if="index!=0">
                            <div class="boxcolor2"></div>
                            <div class="linecolor1"></div>
                        </div>
                        <div v-else>
                            <div class="boxcolor1"></div>
                            <div class="linecolor1"></div>
                        </div>
                        <div :class="index==0&&item.Action!=3?'neth1 colorText1':'neth1'">
                            <div v-if="item.Action==1">以揽件{{item.AcceptTime}}</div>
                            <div v-if="item.Action==2||item.Action==201">运输中{{item.AcceptTime}}</div>
                            <div v-if="item.Action==202">派送中{{item.AcceptTime}}</div>
                            <div v-if="item.Action==211">待取件{{item.AcceptTime}}</div>
                            <div v-if="item.Action==3">已签收{{item.AcceptTime}}</div>
                            <div>{{item.AcceptStation}}</div>
                        </div>
                    </div>

                </div>
                <div class="steps1" v-if="dataList.State==2">
                    <div>
                        <div :class="dataList.State==0?'boxcolor1':'boxcolor2'"></div>
                        <div class="linecolor1"></div>
                    </div>
                    <!-- <div class="neth" :style="dataList.State==0?'color:#000':''">
                    <div>已发货{{tableData.update_time}}</div>
                    <div>等待揽收中</div>
                  </div> -->
                </div>
                <div class="steps1" v-if="showBtn==false">
                    <div>
                        <div class="boxcolor2"></div>
                    </div>
                    <div class="neth">
                        <div>已下单{{dataList.pay_at}}</div>

                    </div>
                </div>
            </div>
        </div>

        <div v-else>
            <div v-if="tableData.activate.shipments.length>1" class="shipper_box">
                <!-- <div class="order" v-if="tableData.activate.shipments.length==1" @click="getOrder">确认收货</div> -->
                <img @click="submitBtn" class="cloneBtn2" style="width:10px;height:10px;" src="../assets/cloneBtn2.png" />
                <div class="loginBtn1">
                    <div style="text-align:right;width:100px;margin-right:30px">物流单号:</div>
                    <div>{{dataList.LogisticCode}}</div>
                </div>
                <div class="loginBtn1">
                    <div style="text-align:right;width:100px;margin-right:30px">收件人:</div>
                    <div>{{tableData.activate.shipments[0].shipments_info.name||''}}</div>
                </div>
                <div class="loginBtn1">
                    <div style="text-align:right;width:100px;margin-right:30px;margin-bottom:50px">收件人地址:</div>
                    <div>{{tableData.activate.shipments[0].shipments_info.address||''}}</div>
                </div>
                <div class="steps1" style="color:#000" v-if="dataList.State==3">
                    <div>
                        <div style="margin-left:-10px" class="boxcolor3">收</div>
                        <div class="linecolor1"></div>
                    </div>
                    <div class="neth">
                        <div style="color:#00000080">[收货地址]{{dataList.Location}}</div>
                        <!-- <div>{{endData.express.Traces[0].AcceptStation}}</div> -->
                    </div>
                </div>
                <div class="steps1" v-for="(item,index) in dataList.Traces" v-bind:key="index">
                    <div v-if="index!=0">
                        <div class="boxcolor2"></div>
                        <div class="linecolor1"></div>
                    </div>
                    <div v-else>
                        <div class="boxcolor1"></div>
                        <div class="linecolor1"></div>
                    </div>
                    <div :class="index==0&&item.Action!=3?'neth colorText':'neth'">
                        <div v-if="item.Action==1">以揽件{{item.AcceptTime}}</div>
                        <div v-if="item.Action==2||item.Action==201">运输中{{item.AcceptTime}}</div>
                        <div v-if="item.Action==202">派送中{{item.AcceptTime}}</div>
                        <div v-if="item.Action==211">待取件{{item.AcceptTime}}</div>
                        <div v-if="item.Action==3">已签收{{item.AcceptTime}}</div>
                        <div>{{item.AcceptStation}}</div>
                    </div>
                </div>
                <div class="steps1" v-if="dataList.State==2">
                    <div>
                        <div :class="dataList.State==0?'boxcolor1':'boxcolor2'"></div>
                        <div class="linecolor1"></div>
                    </div>
                    <!-- <div class="neth" :style="dataList.State==0?'color:#000':''">
                    <div>已发货{{tableData.update_time}}</div>
                    <div>等待揽收中</div>
                  </div> -->
                </div>
                <div class="steps1">
                    <div>
                        <div class="boxcolor2"></div>
                    </div>
                    <div class="neth">
                        <div>已下单{{dataList.pay_at}}</div>

                    </div>
                </div>
            </div>
            <div class="infoBox" v-if="tableData.activate.shipments.length==1">
                <img @click="submitBtn" style="width:10px;height:10px;margin-left:300px" src="../assets/cloneBtn2.png" />
                <div class="auditInfo">物流信息:</div>
                <div class="cart">
                    暂无物流信息
                </div>
            </div>
        </div>

    </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    tableData: {
      type: Object
    },
    dataList: {
      type: Object
    },
    alterationShow: {
      type: Boolean
    },
    showBtn: {
      type: Boolean
    }
  },
  methods: {
    submitBtn() {
      this.$emit("submitBtn");
    }
  }
};
</script>
<style>
.shipper_box {
  width: 700px;
  height: 800px;
  /* background-color: #fff; */
  margin: 200px auto 0;
  font-size: 20px;
  color: #00000080;
  overflow-y: scroll;
  position: relative;
  padding: 50px;
  box-sizing: border-box;
}
.flow_text {
  font-size: 25px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #deb77a;
  text-align: right;
  margin: 25px 0;
}
.flow_contanter {
  padding: 0 38px;
  box-sizing: border-box;
}
.userBtn {
  float: right;
  text-align: center;
}
.userBtn img {
  width: 36px;
  height: 36px;
}
.userBtn div {
  font-size: 15px;
  color: #000;
}
.flow_box {
  width: 37px;
  height: 37px;
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 37px;
  color: #737373;
  opacity: 1;
  text-align: center;
  border: 2px solid #737373;
  border-radius: 50%;
}
.flow_content {
  margin-top: 100px;
}
.line_flow {
  width: 1px;
  border: 1px dashed #737373;
  margin: 0 18px;
  height: 100px;
}
.flow_list {
  display: flex;
  padding: 30px auto;
}
.flow_imgBtn {
  width: 24px;
  height: 24px;
  vertical-align: middle;
  margin: auto 0;
}
.flow_title {
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(115, 115, 115, 0.5);
  margin: 0 10px;
}
.flow_text1 {
  margin-left: 10px;
  font-size: 20px;
  color: #4b93ff;
  margin-top: 15px;
}
.flow_popbox {
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
}
.flow_pop1 {
  width: 600px;
  /* height:700px; */
  background-color: #fff;
  margin: 200px auto 0;
  /* text-align:right; */
  padding: 100px 20px 20px;
  box-sizing: border-box;
  position: relative;
}
.flow_pop1 img {
  position: absolute;
  top: 20px;
  right: 20px;
}
.pop1 {
  font-size: 22px;
}
.pop1 > div {
  margin: 20px 60px;
  text-align: none;
}
.title_pop {
  width: 130px;
  display: inline-block;
  color: #707070ff;
}
.pop3 > div {
  margin-top: 20px;
}
.formList_flow {
  display: flex;
}
.offine_title_flow {
  width: 100px;
  font-size: 22px;
  color: #707070;
  margin: 0;
}
.pop1 .submitBtn {
  width: 160px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  font-size: 25px;
  border: 1px solid #ff5e5e;
  color: #ff5e5e;
  margin: 20px auto 0;
}
.address_text_flow {
  width: 300px;
}
.pop2 > div {
  font-size: 26px;
  color: #707070;
  margin: 20px 0;
}
.pop2 {
  margin-left: 80px;
}
.selectColor {
  color: #ff5e5e;
  border: 1px solid #ff5e5e;
}
.selectLine {
  border: 1px dashed #ff5e5e;
}
@step-icon-size {
  font-size: 40px;
}
.loginBtn1 {
  margin: 20px 0;
  display: flex;
  /* margin-left: 71px */
}
.loginBtn1 > div {
  /* display: flex; */
  /* margin-left: 77px; */
}
.loginBtn1 span {
  margin: 0 5px;
}
.comfigBtn {
  width: 124px;
  height: 40px;
  background-color: #4b93ff;
  border-radius: 5px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 0px;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  margin-left: 79px;
}
.getAddress {
  display: flex;
  margin-left: 70px;
  margin-top: 30px;
}
.steps1 {
  /* height: 200px; */
  display: flex;
  margin-left: 60px;
}
.steps1 .colorText {
  color: #000000;
}
.steps1 .colorText1 {
  color: rgba(251, 87, 39, 1);
  font-size: 25px
}
.steps1 .neth div {
  margin: 5px 0;
}
.neth {
  padding: 5px 0 20px 10px;
}
.neth1 {
  padding: 5px 0 20px 10px;
  font-size: 25px
}
.linecolor {
  width: 1px;
  height: 100%;
  opacity: 1;
  border: 1px dashed #ff5e5e;
  margin-left: 18.5px;
}
.linecolor1 {
  width: 0px;
  height: 100%;
  opacity: 1;
  border: 1px solid #d1d1d1;
  margin-left: 6.5px;
}
.linecolor2 {
  width: 1px;
  height: 100%;
  opacity: 1;
  border: 1px solid #d1d1d1;
  margin-left: 6.5px;
}
.boxcolor {
  width: 37px;
  height: 37px;
  background: #ffffff;
  border: 2px solid #ff5e5e;
  border-radius: 50%;
  opacity: 1;
  text-align: center;
  line-height: 37px;
  color: #ff5e5e;
  font-size: 22px;
}
.boxcolor1 {
  width: 13px;
  height: 13px;
  background: #ff5e5e;
  border-radius: 50%;
  opacity: 1;
}
.boxcolor2 {
  width: 13px;
  height: 13px;
  background: #d1d1d1;
  border-radius: 50%;
  opacity: 1;
}
.boxcolor3 {
  width: 44px;
  height: 44px;
  background: #fc6305;
  border-radius: 50%;
  opacity: 1;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  line-height: 44px;
}
.time_text {
  font-size: 20px;
  color: #000;
  margin: 10px 0 20px 10px;
}
.pop3 {
  height: 776px;
  background: #ffffff;
  font-size: 16px;
  color: #707070;
  padding: 20px 20px 20px 50px;
}
.payClass {
  color: #4b93ff;
  font-size: 25px;
  margin-left: 10px;
}
.ab_list {
  width: 600px !important;
  margin: 0;
  padding: 0;
}
</style>
